import { addMonths, format, isValid, parseISO } from 'date-fns';

import { ContactRoleVettingStep, ContactRoleVettingStepType } from 'types/domain';

export const formatTimestamp = (timestamp: string | Date) => {
  const date = typeof timestamp === 'string' ? parseISO(timestamp) : timestamp;

  return isValid(date) ? format(date, "MMM dd, yyyy, 'at' HH:mm") : 'Unknown date';
};

export const parseDateInputValue = (timestamp?: string | Date | null) => {
  if (!timestamp) {
    return null;
  }

  const date = typeof timestamp === 'string' ? parseISO(timestamp) : timestamp;
  return isValid(date) ? date : null;
};

export const calculateDefaultRetakeDate = (steps: ContactRoleVettingStep[] = []) => {
  const assessmentTypes = [ContactRoleVettingStepType.VoiceAgentCall, ContactRoleVettingStepType.Coderbyte];
  const latestAttemptDate = steps.reduce<Date | null>((latestDate, step) => {
    if (!assessmentTypes.includes(step.type) || !step.startedAt) {
      return latestDate;
    }

    const startedAt = typeof step.startedAt === 'string' ? parseISO(step.startedAt) : step.startedAt;
    if (!isValid(startedAt)) {
      return latestDate;
    }

    return !latestDate || startedAt > latestDate ? startedAt : latestDate;
  }, null);

  return latestAttemptDate ? addMonths(latestAttemptDate, 3) : null;
};

export const formatRetakeDate = (retakeOverride: string | Date | null | undefined, defaultRetakeDate: Date | null) => {
  if (!retakeOverride) {
    return defaultRetakeDate
      ? `${format(defaultRetakeDate, 'MMM dd, yyyy')} · default`
      : 'Default — 3 months after the latest assessment attempt';
  }

  const date = typeof retakeOverride === 'string' ? parseISO(retakeOverride) : retakeOverride;
  return isValid(date) ? format(date, 'MMM dd, yyyy') : 'Invalid retake date';
};

export const formatValueLabel = (value: string) => {
  const label = value
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim();

  return label ? `${label.charAt(0).toUpperCase()}${label.slice(1)}` : value;
};
